import { deleteOne, getAll, postWithResponse, put } from './CommonServices/httpService'
import type {
	BillingLogEntryResponse,
	BillingLogEntryUpsertRequest,
} from '../types/Contracts/BillingLog'

export const getBillingLogEntries = async (): Promise<BillingLogEntryResponse[]> => {
	const res = await getAll<BillingLogEntryResponse[]>('/BillingLog')
	if (!res.success || !res.data) throw new Error('Failed to load billing log entries')
	return res.data
}

export const createBillingLogEntry = async (
	request: BillingLogEntryUpsertRequest,
): Promise<BillingLogEntryResponse> => {
	const res = await postWithResponse<BillingLogEntryResponse>('/BillingLog', request)
	if (!res.success || !res.data) throw new Error('Failed to create billing log entry')
	return res.data
}

export const updateBillingLogEntry = async (
	id: number,
	request: BillingLogEntryUpsertRequest,
): Promise<void> => {
	await put(`/BillingLog/${id}`, request)
}

export const deleteBillingLogEntry = async (id: number): Promise<void> => {
	await deleteOne(`/BillingLog/${id}`)
}
